import { Component, OnInit } from '@angular/core';
import { CustomDataService } from 'src/app/services/custom-data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-movie',
  templateUrl: './movie.component.html',
  styleUrls: ['./movie.component.css']
})
export class MovieComponent implements OnInit {
show ; Url ;searchValue  ; id
  constructor(private custom:CustomDataService , private _activatedroute:ActivatedRoute , private _router:Router) 
  {
    
   
   }

  ngOnInit() {
  }
  
}
